import { useEffect } from 'react';
import { useDocument } from '@nandorojo/swr-firestore';
import { ISoundEffect } from '@typings/setting/soundEffect.interface';
import { SettingCollectionPath } from '@typings/collections.enum';
import { useAudioPlayer } from './useAudioPlayer';

export function useGlobalClickSound() {
  const { data: soundEffect } = useDocument<ISoundEffect>(
    SettingCollectionPath.SOUNDEFFECT,
    { listen: true },
  );

  const listUrl = soundEffect?.listSound?.url;
  const buttonUrl = soundEffect?.buttonSound?.url;

  const { play } = useAudioPlayer(
    {
      default: buttonUrl,
      menu: listUrl,
      list: listUrl || buttonUrl, // listSound 미설정 시 buttonSound fallback
      card: soundEffect?.cardSound?.url,
    },
    Number(soundEffect?.volume) || 0.3,
  );

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (!soundEffect?.isActive) return;

      const target = e.target as HTMLElement;
      const soundType = target
        .closest('[data-sound-type]')
        ?.getAttribute('data-sound-type') as 'menu' | 'list' | 'card';

      switch (soundType) {
        case 'card':
          play('card');
          break;
        case 'menu':
        case 'list':
        default:
          play('list');
          break;
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [soundEffect?.isActive, play]);
}
